// extracted by mini-css-extract-plugin
export default {"tabs":"M7-z","tablist":"N7-z","tablistItem":"O7-z"};